module.exports = __webpack_public_path__ + "static/img/banner8.36cc0f3d.png";